/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListPostsInAThread200ResponseLinks
 */
export interface ListPostsInAThread200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListPostsInAThread200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPostsInAThread200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListPostsInAThread200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListPostsInAThread200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListPostsInAThread200ResponseLinks interface.
 */
export function instanceOfListPostsInAThread200ResponseLinks(value: object): value is ListPostsInAThread200ResponseLinks {
    return true;
}

export function ListPostsInAThread200ResponseLinksFromJSON(json: any): ListPostsInAThread200ResponseLinks {
    return ListPostsInAThread200ResponseLinksFromJSONTyped(json, false);
}

export function ListPostsInAThread200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPostsInAThread200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListPostsInAThread200ResponseLinksToJSON(json: any): ListPostsInAThread200ResponseLinks {
    return ListPostsInAThread200ResponseLinksToJSONTyped(json, false);
}

export function ListPostsInAThread200ResponseLinksToJSONTyped(value?: ListPostsInAThread200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

